import React from 'react';
import { Box } from '@mui/material';
import MySkeleton from '../../../../components/Skeleton';

const CalendarLoader = () => {
    return (
        <Box className="CallsTableBox">
            <Box className="MeetingCard">
                <Box className="MeetingCardMain">
                    <Box className="MeetingCardDate">
                        <MySkeleton variant="rounded" width={56} height={80} bg="#2A2A2A" />
                    </Box>
                    <Box className="MeetingCardDetails">
                        <MySkeleton width={'70%'} height={18} bg="#2A2A2A" />
                        <Box className="MeetingCardMeta" style={{ width: '100%' }}>
                            <MySkeleton width={'40%'} height={14} bg="#2A2A2A" />
                            <span className="MeetingCardMetaDivider" />
                            <MySkeleton width={'20%'} height={14} bg="#2A2A2A" />
                            <span className="MeetingCardMetaDivider" />
                            <MySkeleton width={'30%'} height={14} bg="#2A2A2A" />
                        </Box>
                    </Box>
                </Box>
                <Box className="MeetingCardCtas">
                    <MySkeleton width={110} height={36} bg="#2A2A2A" />
                    <Box className="MeetingCardActionButtons">
                        <MySkeleton width={'100%'} height={36} bg="#2A2A2A" />
                        <MySkeleton width={'100%'} height={36} bg="#2A2A2A" />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default CalendarLoader;
